import React from 'react';
import { useIsFetching, useIsMutating } from 'react-query';
import { useSelector } from 'react-redux';
import Loader from 'react-loader';

function GlobalLoader(props) {
  const loaded = useSelector((state) => state.global.loaded);
  return <Loader loaded={loaded} />;
}

export default GlobalLoader;

export function GlobalFetchLoader() {
  const isFetching = useIsFetching();
  return <Loader loaded={isFetching === 0} />;
}
export function GlobalMutateLoader() {
  const isMutating = useIsMutating();
  return <Loader loaded={isMutating === 0} />;
}
